import React from 'react';
import { Navigate, Outlet, Link, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import styles from '../../assets/styles/Admin.module.scss';
import dashboardIcon from '../../assets/icons/report-analytics.svg';
import clientsIcon from '../../assets/icons/database-icon.svg';
import paymentsIcon from '../../assets/icons/icon-budget.svg';
import inquiriesIcon from '../../assets/icons/bell.svg';

const AdminLayout: React.FC = () => {
  const { user, loading } = useUser();
  const location = useLocation();

  if (loading) return null;

  // Protect the route: if not logged in, or not admin, redirect.
  // In development, if you need to bypass this, you might temporarily disable this check or ensure your user has is_admin=true
  // if (!user || !user.is_admin) {
  //   return <Navigate to="/" replace />;
  // }
  // Note: Un-comment the strict check when real backend data `is_admin` is integrated. 
  // For now, we will assume anyone accessing /admin is allowed during MVP if user exists, but let's be strict based on the requirement:
  if (!user || !user.is_admin) {
    return <Navigate to="/login" replace />;
  }

  const navItems = [
    { name: 'ダッシュボード', path: '/admin', icon: dashboardIcon },
    { name: 'クライアント管理', path: '/admin/clients', icon: clientsIcon },
    { name: '新規会員登録', path: '/admin/registrations', icon: clientsIcon },
    { name: 'お問い合わせ', path: '/admin/inquiries', icon: inquiriesIcon },
    { name: '決済状況', path: '/admin/payments', icon: paymentsIcon },
  ];

  return (
    <div className={styles.adminWrap}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarTitle}>
          <img src={dashboardIcon} alt="Admin" />
          管理者ポータル
        </div>
        <ul className={styles.navList}>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || (item.path !== '/admin' && location.pathname.startsWith(item.path));
            return (
              <li key={item.path}>
                <Link to={item.path} className={`${styles.navItem} ${isActive ? styles.active : ''}`}>
                  <img src={item.icon} alt={item.name} />
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
        <div className={styles.backToServiceWrap}>
          <Link to="/" className={styles.navItem}>
            <span className={styles.backArrow}>←</span>
            サービス画面に戻る
          </Link>
        </div>
      </aside>
      <main className={styles.mainContent}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
